import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = ['streets-filter'];

const getStreet = async () => {
  return await request.get(
    `/Filter/streets`,
    {},
    'При получении списка улиц произошла ошибка'
  );
};

const useStreetQuery = (options = {}) => useQuery(key, getStreet, options);

export default useStreetQuery;
